import styled from "styled-components";

const getBackground = (brand, category) => {
  const backgrounds = {
    'dr-reckeweg': {
      'goteros': '#E20200',
      'procaina-kholer': '#1E384F',
      'sales': '#4D4D4D',
      default: '#E20200',
    },
    'tegor': {
      default: '#F5CA41'
    },
    'helixor': {
      'helixor-a': 'rgb(255, 184, 5)',
      'helixor-m': '#D66415',
      'helixor-p': '#DA0024',
       default: '#D71B20'
    },
    'symbio-pharm': {
      'symbioflor-1': '#D71B20',
      'symbioflor-2': 'rgb(167, 226, 252)',
      'symbiolact-comp': 'rgb(159, 108, 224) ',
      'symbiointest': 'rgb(205, 241, 98)',
      default: '#D71B20'
    },
    'regenhial': {
      default: '#9C9C9C'
    },
    default: '#000001'
  };

  const brandBackgrounds = backgrounds[brand] || backgrounds.default;
  return category ? (brandBackgrounds[category] || brandBackgrounds.default) : brandBackgrounds.default;
};

export const Container = styled.div`
  width: 90%;
  margin: 40px auto;

  @media (max-width: 1100px) {
    /* Tablets */
    width: 85%;
  }

  @media (max-width: 550px) {
    /* Phones */
    width: 85%;
  }

  /* Slider arrow styles */
  .slick-prev,
  .slick-next {
    &:before {
      color: rgba(40, 44, 52, 1);
      opacity: 0.5;
      font-size: 24px;
      transition: color 0.3s ease;
    }

    &:hover:before {
      color: rgba(234, 11, 42, 1);
    }
  }

  .slick-prev {
    left: -35px;
    &:empty {
      display: none;
    }
  }

  .slick-next {
    right: -35px;
  }

  .slider-container {
    position: relative;
    
    &.hide-left-arrow {
      .slick-prev {
        opacity: 0;
        pointer-events: none;
      }
    }
  }

  /* Single item alignment */
  .slick-slider {
    display: block;
  }

  .slick-list {
    margin: 0;
    padding: 0;
  }

  .slick-track {
    margin-left: 0;
    display: flex !important;
    justify-content: flex-start;
  }

  .slick-slide {
    float: none;
    height: auto;
  }

  .slick-slide > div {
    margin: 0;
  }
`;

export const Card = styled.div`
  width: ${props => props.isSingleItem ? '100%' : '85%'};
  max-width: ${props => props.isSingleItem ? '400px' : 'none'};
  min-height: 400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: rgb(245, 245, 245);
  padding: 20px;
  border-radius: 30px;
  text-align: center;

  img {
    width: ${props => props.isSingleItem ? '16em' : '12em'};
    height: auto;
    object-fit: contain;
  }

  @media (max-width: 1100px) {
    width: ${props => props.isSingleItem ? '80%' : '250px'};
    min-height: 380px;
  }

  @media (max-width: 550px) {
    width: ${props => props.isSingleItem ? '90%' : '220px'};
    min-height: 350px;
  }
`;

export const Image = styled.div`
  width: 100%;
  height: 180px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 2em;

  img {  
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (max-width: 550px) {
    height: 160px;
  }
`;

export const Circle = styled.div`
 background: ${props => getBackground(props.brand, props.category)};
  width: 150px;
  height: 150px;
  border-radius: 50%;
`

export const Title = styled.h3`
  margin-top: 1em;
  font-size: 18px;
  color: #333;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #666;
  height: 40px;
  font-style: italic;
`;

export const Button = styled.button`
  background-color: rgba(40, 44, 52, 1);
  color: rgb(255, 255, 255);
  border: 1px solid rgba(40, 44, 52, 1);
  padding: 10px 30px;
  border-radius: 30px;
  font-size: 0.9em;
  cursor: pointer;
  margin-top: 1.5em;
  text-decoration: none;

  &:hover {
    background-color: rgba(234, 11, 42, 1);
    border: 1px solid rgba(234, 11, 42, 1);
    color: white;
  }
`;

export const SliderTitle = styled.h2`
    margin: 10px 0;
`
